export * from './workouts.model';



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/store/index.ts